import { render, staticRenderFns } from "./SectionOrder.vue?vue&type=template&id=265fbca4"
import script from "./SectionOrder.vue?vue&type=script&lang=js"
export * from "./SectionOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports